import React from "react";
import "./footer.css";

export default function Footer(props) {
  return (
    <div id={props.id}>@2022 Commercial Scape LLC. All rights reserved.</div>
  );
}
